<template>
  <v-container class="branding-container">
    <v-row>
      <v-col cols="3" class="d-flex flex-column justify-space-between">
        <EcsBusinessProcess />
        <EcsInterfaceStyle />
        <EcsColorSettings />
      </v-col>
      <v-col cols="6" class="d-flex flex-column justify-space-between">
        <EcsDisplayComponents />
      </v-col>
      <v-col cols="3" class="d-flex flex-column justify-space-between">
        <EcsFilePicker @previewChange="onPreviewChange" />
        <EcsFontPicker />
        <EcsAdditionalOptions />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import EcsDisplayComponents from '@/components/ecs-display-components/EcsDisplayComponents';
import EcsBusinessProcess from '@/components/ecs-business-process/EcsBusinessProcess';
import EcsInterfaceStyle from '@/components/ecs-interface-style/EcsInterfaceStyle';
import EcsColorSettings from '@/components/ecs-color-settings/EcsColorSettings';
import EcsFilePicker from '@/components/ecs-file-picker/EcsFilePicker';
import EcsFontPicker from '@/components/ecs-font-picker/EcsFontPicker';
import EcsAdditionalOptions from '@/components/ecs-additional-options/EcsAdditionalOptions';
import { mapActions } from 'vuex';

export default {
  name: 'Branding',

  components: {
    EcsBusinessProcess,
    EcsInterfaceStyle,
    EcsColorSettings,
    EcsFilePicker,
    EcsFontPicker,
    EcsAdditionalOptions,
    EcsDisplayComponents
  },

  methods: {
    ...mapActions(['setLogo']),
    onPreviewChange(payload) {
      this.setLogo({ payload, vuetify: this.$vuetify });
    }
  }
};
</script>
<style scoped>
.branding-container {
  max-width: none;
  height: 100%;
  display: flex;
  padding: 12px 36px;
}
</style>
